import React from 'react';
import { motion } from 'framer-motion';
import { Wallet, ShieldCheck, UserCheck } from 'lucide-react';

const TrustCard: React.FC<{
  icon: React.ReactNode;
  title: string;
  description: string;
  glowColor: string;
  delay: number;
}> = ({ icon, title, description, glowColor, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.02, y: -5 }}
    className="group relative p-3 md:p-8 rounded-xl md:rounded-[2rem] border border-white/10 bg-white/5 backdrop-blur-2xl overflow-hidden h-full flex flex-col items-center md:items-start text-center md:text-left"
  >
    <div
      className="absolute -top-10 -right-10 w-64 h-64 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-700 blur-[80px] pointer-events-none"
      style={{ backgroundColor: glowColor }}
    />
    <div className="relative mb-2 md:mb-6">
      <div className="text-white opacity-90 group-hover:opacity-100 transition-opacity duration-300">
        {React.cloneElement(icon as React.ReactElement<any>, {
          className: "stroke-white w-6 h-6 md:w-12 md:h-12",
          strokeWidth: 1.5,
        })}
      </div>
    </div>
    <h3 className="relative text-xs md:text-2xl font-semibold text-white mb-1 md:mb-4 z-10">{title}</h3>
    <p className="relative text-[10px] md:text-base text-gray-400 leading-tight md:leading-relaxed font-light z-10 group-hover:text-gray-300 transition-colors">
      {description}
    </p>
  </motion.div>
);

const RevenueModel: React.FC = () => {
  return (
    <section id="trust" className="py-16 md:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-8 md:mb-16"
        >
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">0抽成 真正免佣金</h2>
          <p className="text-sm md:text-xl text-gray-500">
            平台不分钱，你的设计费100%全到手
          </p>
        </motion.div>

        <div className="grid grid-cols-3 gap-2 md:gap-8">
          <TrustCard
            icon={<Wallet />}
            title="真正免佣金"
            description="只需开通好绘AI作图工具会员，不再收取任何额外费用。"
            glowColor="#f59e0b"
            delay={0}
          />
          <TrustCard
            icon={<ShieldCheck />}
            title="资金秒到账"
            description="商单资金 100% 平台托管，甲方确认验收后，资金秒到你的银行账户。"
            glowColor="#06b6d4"
            delay={0.1}
          />
          <TrustCard
            icon={<UserCheck />}
            title="纠纷有兜底"
            description="遇到商单纠纷，平台 1v1 客服协助沟通，必要时介入裁决，保障设计师权益。"
            glowColor="#ec4899"
            delay={0.2}
          />
        </div>
      </div>
    </section>
  );
};

export default RevenueModel;